module.exports = __webpack_public_path__ + "media/images/flags/16/Antigua-and-Barbuda-f4d9acffe10f0d9d4b9319ffcc6c4c2b.png";